import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const moveInventoryRoutes: RouteRecordRaw[] = [
  {
    path: '/move-inventory',
    name: 'move-inventory',
    component: () => import('./views/MoveInventoryView.vue'),
    meta: {
      title: () => i18next.t('nav.moveInventory', 'Move Inventory'),
      // Move Inventory is part of every package and outside the scope of entitlements —
      // accessible to any role except Auditor and the (role-less) Default role.
      excludedRoles: ['AUDITOR', 'DEFAULT'],
      breadcrumbs: [{ label: () => i18next.t('nav.moveInventory', 'Move Inventory') }],
    },
  },
];
